import type { SxProps, Theme } from '@mui/material';

export const styles = {
    title: { fontWeight: 600 } as SxProps<Theme>,
    subtitle: {
        color: 'grey.500',
        fontSize: '14px',
        mb: 3,
    } as SxProps<Theme>,
    formStack: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
    } as SxProps<Theme>,
    rating: {
        fontSize: '65px',
    } as SxProps<Theme>,
    noteField: { maxWidth: 384, width: '100%' } as SxProps<Theme>,
    submitBtn: (active: boolean, theme: Theme): SxProps<Theme> => ({
        width: '100%',
        maxWidth: 384,
        backgroundColor: active ? theme.palette.blue.main : theme.palette.grey[50],
        color: active ? 'white' : theme.palette.grey[200],
        textTransform: 'uppercase',
        borderRadius: 2,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: active ? theme.palette.blue[800] : theme.palette.grey[100],
        },
    }),
};
